import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useState } from "react";

export const ReportAppendixB = ({ data }) => {
  const [courseWiseData] = useState(data.course_wise_report);

  const columns = [
    { id: "sl_no", label: "Sl. No." },
    { id: "course_name", label: "Course" },
    { id: "total_usage", label: "Total Usage (Hours)" },
  ];

  return (
    <div className="report-appendixB-container">
      <Typography
        sx={{
          fontSize: "35px",
          fontWeight: "bold",
          textAlign: "center",
          marginTop: "30px",
        }}
      >
        Appendix B: Course-wise Usage Report
      </Typography>
      <TableContainer component={Paper} className="table m-1 mt-4">
        <Table id="summary" className="mb-0">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.id}>{column.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {courseWiseData.map((row, index) => {
              return (
                <TableRow key={row.crs_id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>{row.crs_title}</TableCell>
                  <TableCell>{Math.ceil(row.view_time_in_hours)}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
